import '../App.css';
import React, { useEffect } from 'react';
import { auth } from '../firebase';
import { useState } from 'react';
import { signInAnonymously } from "firebase/auth";
import { logDemographics, logNewUser, logPostHighlightSurvey, logPostTestSurvey } from '../logging.js';
import { TextField, Flex, Button, Form, Provider, defaultTheme, Text, Heading, Radio, RadioGroup, ContextualHelp, Content, CheckboxGroup, Checkbox, TextArea, Slider } from '@adobe/react-spectrum';

function PostTestForm({participantId, frequencyWording, passageId, condition, callbacks}) {
    // Results
    const [frequency, setFrequency] = useState(0);
    const [perceivedScore, setPerceivedScore] = useState(0);

    // TLX
    const [mentalDemand, setMentalDemand] = useState(0);
    const [physicalDemand, setPhysicalDemand] = useState(0);
    const [temporalDemand, setTemporalDemand] = useState(0);
    const [performance, setPerformance] = useState(0);
    const [effort, setEffort] = useState(0);
    const [frustration, setFrustration] = useState(0);
 
    const [experience, setExperience] = useState('');
    const [otherTools, setOtherTools] = useState('');
    const [additionalComments, setAdditionalComments] = useState('');

    // Validation
    const [formValidated, setFormValidated] = useState(false);

    useEffect(() => {
        validateForm();
    }, [frequency, perceivedScore, experience, otherTools, additionalComments]);

    function validateForm() {
        if (frequency > 0 && perceivedScore > 0 && experience !== '' && otherTools !== '' && mentalDemand > 0 && physicalDemand > 0 && temporalDemand > 0 && performance > 0 && effort > 0 && frustration > 0) {
            setFormValidated(true);
        }

        else {
            setFormValidated(false);
        }
    }

    function submitForm(e) {
        e.preventDefault();
        var results = {
            mentalDemand: mentalDemand,
            physicalDemand: physicalDemand,
            temporalDemand: temporalDemand,
            performance: performance,
            effort: effort,
            frustration: frustration,
            frequency: frequency,
            perceivedScore: perceivedScore,
            otherTools: otherTools,
            experience: experience,
            additionalComments: additionalComments,
            participantId: participantId,

            // new for within
            passageId: passageId,
            condition: condition,
        }

        logPostTestSurvey(results, callbacks);
    }

    return (
        <>    
            <Provider theme={defaultTheme} colorScheme='light'>
                <Flex direction="column" justifyContent={'center'} alignItems={"center"}>             
                    <div id="textToRead" className='documentReader'>
                        <Heading level={1} width="100%" marginBottom="size-100" marginTop="size-0">Post-Test Questions</Heading>
                        <Text>Please answer the following questions about your experience writing the test about the passage.  <b>All questions are mandatory unless indicated otherwise.</b></Text> 
                        <Form onSubmit={e => submitForm(e)}>    
                            {/* Frequency */}
                            <RadioGroup onChange={setFrequency} marginBottom="size-100" orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">How often did you refer back to the passage {frequencyWording} while answering the questions?</Heading>}>                     
                                <Text marginEnd={"size-700"} marginTop={"size-50"}>Never</Text>
                                {[...Array(7)].map((e, i) => <Radio  value={(i+1)}>{(i+1)}</Radio>)}
                                <Text marginStart={"size-500"} marginTop={"size-50"}>Very often</Text>
                            </RadioGroup> 

                            {/* Mental Demand */}
                            <RadioGroup marginBottom="size-100" onChange={setMentalDemand} orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">How mentally demanding was the task?</Heading>}>                     
                                <Text marginEnd={"size-500"} marginTop={"size-50"}>Very low</Text>
                                {[...Array(7)].map((e, i) => <Radio  value={(i+1)}>{(i+1)}</Radio>)}
                                <Text marginStart={"size-500"} marginTop={"size-50"}>Very high</Text>
                            </RadioGroup>  
                            
                            {/* Physical Demand */}
                            <RadioGroup marginBottom="size-100" onChange={setPhysicalDemand} orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">How physically demanding was the task?</Heading>}>                     
                                <Text marginEnd={"size-500"} marginTop={"size-50"}>Very low</Text>
                                {[...Array(7)].map((e, i) => <Radio  value={(i+1)}>{(i+1)}</Radio>)}
                                <Text marginStart={"size-500"} marginTop={"size-50"}>Very high</Text>
                            </RadioGroup>  

                            {/* Temporal Demand */}
                            <RadioGroup marginBottom="size-100" onChange={setTemporalDemand} orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">How hurried or rushed was the pace of the task?</Heading>}>                     
                                <Text marginEnd={"size-500"} marginTop={"size-50"}>Very low</Text>
                                {[...Array(7)].map((e, i) => <Radio  value={(i+1)}>{(i+1)}</Radio>)}
                                <Text marginStart={"size-500"} marginTop={"size-50"}>Very high</Text>
                            </RadioGroup>  
                            
                            {/* Performance */}
                            <RadioGroup marginBottom="size-100" onChange={setPerformance} orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">How successful were you in accomplishing what you were asked to do?</Heading>}>                     
                                <Text marginEnd={"size-600"} marginTop={"size-50"}>Failure</Text>
                                <Text marginEnd={"size-50"}></Text>
                                {[...Array(7)].map((e, i) => <Radio  value={(i+1)}>{(i+1)}</Radio>)}
                                <Text marginStart={"size-500"} marginTop={"size-50"}>Perfect</Text>
                            </RadioGroup>  

                            {/* Perceived Score */}
                            <RadioGroup onChange={setPerceivedScore} marginBottom="size-100" orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">How well do you think you did on the test?</Heading>}>                     
                                <Text marginEnd={"size-600"} marginTop={"size-50"}>Failure</Text>
                                <Text marginEnd={"size-50"}></Text>
                                {[...Array(7)].map((e, i) => <Radio  value={(i+1)}>{(i+1)}</Radio>)}
                                <Text marginStart={"size-500"} marginTop={"size-50"}>Perfect</Text>
                            </RadioGroup>  

                            {/* Effort */}
                            <RadioGroup marginBottom="size-100" onChange={setEffort} orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">How hard did you have to work to answer the questions on the test?</Heading>}>                     
                                <Text marginEnd={"size-500"} marginTop={"size-50"}>Very low</Text>
                                {[...Array(7)].map((e, i) => <Radio  value={(i+1)}>{(i+1)}</Radio>)}
                                <Text marginStart={"size-500"} marginTop={"size-50"}>Very high</Text>
                            </RadioGroup>  

                            {/* Frustration */}
                            <RadioGroup marginBottom="size-100" onChange={setFrustration} orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">How insecure, discouraged, irriated, stressed, and annoyed were you?</Heading>}>                     
                                <Text marginEnd={"size-500"} marginTop={"size-50"}>Very low</Text>
                                {[...Array(7)].map((e, i) => <Radio  value={(i+1)}>{(i+1)}</Radio>)}
                                <Text marginStart={"size-500"} marginTop={"size-50"}>Very high</Text>
                            </RadioGroup>

                            {/* Experience */}
                            <TextArea onChange={setExperience} marginBottom="size-100" label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">Focusing on 2 or 3 points, how beneficial was it to have access to the passage {frequencyWording} while answering the questions?</Heading>} />                 

                            {/* Other studying tools */}
                            <TextArea onChange={setOtherTools} marginBottom="size-100" label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">Did you use any other tools/studying strategies for the test? For example, copying/pasting the contents into a separate document, taking a screenshot of the passage and reviewing it, writing other notes on paper/a separate text editor, etc.?</Heading>} />                 

                            {/* Additional Comments */}
                            <TextArea onChange={setAdditionalComments} marginBottom="size-100" label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">Do you have any additional comments about your experience writing the test? (optional)</Heading>} />                 
  
                            <Button variant='primary' type="submit" style='fill' marginTop="size-600" isDisabled={!formValidated}>Submit</Button>
                        </Form>
                    </div>
                </Flex>
            </Provider>
        </>
    );
}

export default PostTestForm;